import { cn } from '../../lib/cn';
import type { NotificationRow } from '../../mobilecompanion/framework';

type Props = { notifications?: NotificationRow[] };

export function NotificationCenterPanel({ notifications = [] }: Props) {
  return (
    <div className="space-y-2">
      {notifications.map((n) => (
        <div key={n.title} className={cn(
          'flex items-start justify-between gap-3 rounded-lg border p-3',
          n.read ? 'border-slate-200 dark:border-slate-700' : 'border-brand-200 bg-brand-50/50 dark:border-brand-900 dark:bg-brand-950/30',
        )}>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-slate-500">{n.category}</p>
            <p className={cn('mt-0.5 text-sm', !n.read && 'font-medium')}>{n.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{n.time}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            n.priority === 'critical' ? 'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300' :
            n.priority === 'high' ? 'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {n.priority}
          </span>
        </div>
      ))}
    </div>
  );
}
